import React, { useCallback } from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import NavbarBrand from 'react-bootstrap/NavbarBrand'
import NavDropdown from 'react-bootstrap/NavDropdown'
import styled from 'styled-components'
import { generatePath } from 'react-router-dom'
import logo from 'assets/images/app_lake_logo.png'
import { APP_ROUTES } from 'app/components/AppRouter/routes'
import { isTokenExpired } from 'app/utils/hooks'

const Logo = styled.img`
    height: 40px;
`

const StyledNavbar = styled(Navbar)`
    background-color: rgb(115, 115, 115);
    color: rgba(255, 255, 255, 0.5);
    justify-content: space-between;
    padding-left: 10px;
    padding-right: 10px;
`

const StyledNavLink = styled(Nav.Link)`
    color: rgba(255, 255, 255, 0.5);
    &:hover {
        color: rgb(255, 255, 255);
    }
`

const StyledDropdown = styled(NavDropdown)`
    a {
        color: rgba(255, 255, 255, 0.5);
    }

    a:hover {
        color: rgb(255, 255, 255);
    }

    div {
        background-color: rgb(115, 115, 115);
    }
`

const StyledDropdownItem = styled(NavDropdown.Item)`
    color: rgba(255, 255, 255, 0.5);
    background-color: rgb(115, 115, 115);

    &:hover {
        background-color: rgb(145, 145, 145);
        color: rgb(255, 255, 255);
    }
`

const Header = () => {
    const logoutCallback = useCallback(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('tokenExpired')
    }, [])

    return (
        <StyledNavbar>
            <NavbarBrand href={generatePath(APP_ROUTES.ROOT)}>
                <Logo src={logo} />
            </NavbarBrand>
            <Nav>
                {!isTokenExpired() && (
                    <StyledNavLink href={generatePath(APP_ROUTES.ADD_APP)}>
                        Add new app
                    </StyledNavLink>
                )}
                {isTokenExpired() && (
                    <StyledNavLink href={generatePath(APP_ROUTES.ROOT)}>
                        Applications
                    </StyledNavLink>
                )}
                {!isTokenExpired() && (
                    <StyledNavLink
                        href={generatePath(APP_ROUTES.VIEW_APPS_EDITOR)}>
                        Manage Applications
                    </StyledNavLink>
                )}
                {/*{isTokenExpired() && (*/}
                {/*    <StyledNavLink href={generatePath(APP_ROUTES.LOGIN)}>*/}
                {/*        Login*/}
                {/*    </StyledNavLink>*/}
                {/*)}*/}
                {!isTokenExpired() && (
                    <StyledDropdown title="Account" align="end">
                        <StyledDropdownItem href={APP_ROUTES.USER_VIEW}>
                            Users Management
                        </StyledDropdownItem>
                        <NavDropdown.Divider />
                        <StyledDropdownItem
                            href={generatePath(APP_ROUTES.ROOT)}
                            onClick={logoutCallback}>
                            Log out
                        </StyledDropdownItem>
                    </StyledDropdown>
                )}
            </Nav>
        </StyledNavbar>
    )
}

export default Header
